import css from 'styled-jsx/css';

export default css`.search-bar-hot-word {
    width: 100%;
    overflow: hidden;
    height: 22px;
    margin-top: 16px;
    padding-left: 16px;
    display: flex;
    flex-wrap: wrap;
    color: #999;

    &-item {
      margin-left: 16px;
      font-size: 14px;
      line-height: 22px;
      color: #999;
      cursor: pointer;
    }

    &-item:hover {
      color: #FF6400;
    }
  }`